import React, { useState } from "react";
import CategoryHeader from "../../../Components/Headers/CategoryHeader";
import VerifyEKYC from "../EKYC/VerifyEKYC";
import DocUpload from "../UploadDocument/DocUpload";
import FormCKYC from "./FormCKYC";

const VerifyCKYC = (props) => {
  const {
    CKYC,
    setCKYC,
    EKYC,
    setEKYC,
    setNext,
    decryptedResponseId,
    decryptedAcuvisor_product_id,
    productName,
    quickQuoteDetails,
  } = props;

  return (
    <div>
      {
        // productName ===70001?
        // <>STar</>
        // :
        <FormCKYC
          CKYC={CKYC}
          setCKYC={setCKYC}
          EKYC={EKYC}
          setEKYC={setEKYC}
          setNext={setNext}
          quickQuoteDetails={quickQuoteDetails}
          decryptedResponseId={decryptedResponseId}
          decryptedAcuvisor_product_id={decryptedAcuvisor_product_id}
        />
      }
    </div>
  );
};

export default VerifyCKYC;
